import { render, staticRenderFns } from "./CustomerServiceTrackingNew.vue?vue&type=template&id=4ad19a73&scoped=true&"
import script from "./CustomerServiceTrackingNew.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceTrackingNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceTrackingNew.vue?vue&type=style&index=0&id=4ad19a73&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad19a73",
  null
  
)

export default component.exports